import { render, staticRenderFns } from "./base-btn.vue?vue&type=template&id=ee71deac"
import script from "./base-btn.vue?vue&type=script&lang=ts"
export * from "./base-btn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports